app.mediator.registerModule(MODULE_NAME__SOCIAL_LINKS, function (app) {
    return {

        $rootElem: null,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {

            // Init
            var scope = this;
            this.$rootElem = $('.mod-social-links');

            // Remove transition delay if popped in
            $('.mod-social-links .social-link').mouseover(function () {
                var $popWrap = $(this).closest('.pop-in');
                if ($popWrap.hasClass('popped-in')) {
                    $(this).addClass('no-transition-delay');
                }
            });

            $('.mod-social-links .pop-in').on('pop.popped',  function () {
                setTimeout(function () {
                    $('.mod-social-links .social-link').each(function (k, v) {
                        var $v = $(v);
                        var $popWrap = $v.closest('.pop-in');
                        if ($popWrap.hasClass('popped-in')) {
                            $v.addClass('no-transition-delay');
                        }
                    });
                }, 1000);
            });

            // Mediator event listeners
            app.mediator.addListener(EVENT_NAME__GALLERY__GALLERY_WITH_INFINITE_SCROLL_INITIATED, function () {
                // If the page has an infinite scroll gallery, we want to hide the footer,
                // until we have reached the last of the gallery items.
                scope.hide();
            });

            app.mediator.addListener(EVENT_NAME__GALLERY__BOTTOM_OF_INFINITE_SCROLL_REACHED, function () {
                scope.show();
            });
        },

        //==========================================================xdiv2====
        // Module
        //===================================================================

        hide: function () {
            this.$rootElem.addClass('hidden');
        },

        show: function () {
            this.$rootElem.removeClass('hidden');
        },

    };
});
